import React from 'react';
import PropTypes from 'prop-types';
import SubHeadingStyles from './SubHeading.styled';
import theme from '../../styles/theme';
import { useInView } from 'react-intersection-observer';

const SubHeading = ({
  children,
  background = theme.colors.claytonBlue,
  appearance = 'light',
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  return (
    <SubHeadingStyles
      ref={ref}
      className={`block-sub-heading ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
      appearance={appearance}
      background={background}
    >
      <div className='inner'>{children}</div>
    </SubHeadingStyles>
  );
};

SubHeading.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  appearance: PropTypes.oneOf(['light', 'dark']),
  background: PropTypes.string,
  isAnimated: PropTypes.bool,
};

export default SubHeading;
